import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';


@Injectable()
export class UsersService {

  constructor(
    private apiService: ApiService
  ) {
  }

  getAll() {
    return this.apiService.get(`/users`)
      .pipe(
        map((result) => result.data)
      );
  }

  get(id) {
    return this.apiService.get(`/users/${id}`)
      .pipe(
        map((result) => result.data)
      );
  }

  create(user) {
    return this.apiService.upload(`/users`, user);
  }

  update(id, user) {
    return this.apiService.upload(`/users/${id}`, user);
  }

  destroy(id) {
    return this.apiService.delete(`/users/${id}`);
  }

}
